module.exports = __webpack_public_path__ + "img/bx-copy.579cd32f.svg";